import { ApiRequestError } from "./api";

export type DriverIdentityConflict = {
  field: "document" | "email";
  message: string;
};

const DOCUMENT_CONFLICT_MESSAGE = "El documento ya está registrado";
const EMAIL_CONFLICT_MESSAGE = "El correo electrónico ya está registrado";

export function getDriverIdentityConflict(
  error: unknown,
): DriverIdentityConflict | null {
  if (!(error instanceof ApiRequestError) || error.status !== 409) {
    return null;
  }

  switch (error.code) {
    case "DRIVER_DOCUMENT_DUPLICATED":
      return { field: "document", message: DOCUMENT_CONFLICT_MESSAGE };
    case "DRIVER_EMAIL_DUPLICATED":
    case "EMAIL_REGISTERED_AS_USER":
      return { field: "email", message: EMAIL_CONFLICT_MESSAGE };
    default:
      return null;
  }
}
